export function buildApiUrl(endpoint, params) {
    // console.log("buildApiUrl(" + endpoint + ")")
    let fullEndpoint
    if (process.env.VUE_APP_API_URL.startsWith("/")) {
        // No full hostname; fallback to current
        fullEndpoint = document.location.origin + process.env.VUE_APP_API_URL + endpoint
    } else {
        fullEndpoint = process.env.VUE_APP_API_URL + endpoint
    }

    // console.log("fullEndpoint: " + fullEndpoint)
    let urlObj = new URL(fullEndpoint)
    let url = `${urlObj.href}`
    if (params) {
        let searchParams = new URLSearchParams(params)
        url = `${urlObj.href}?${searchParams.toString()}`
    }
    return url
}
